import { Box, Button, Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import { DeleteIcon, UploadIcon } from '../../layouts/dashboard/nav/IconButton';
import { SelectImage } from '../style/CommonStyle';
import _ from 'lodash';

export default function ImageInput({
  form,
  fieldPath = '',
  fieldUrl = '',
  fieldName = '',
}: any) {
  const fileInputRef = useRef<any>();

  function onSelect(e: any) {
    e.preventDefault();
    const img = e.target.files[0];
    if (!!img) {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function () {
        const imgUrl = reader.result;
        form.setValue(`${fieldName}Url`, imgUrl);
      };
      form.setValue(`${fieldPath}`, img);
    }
  }
  const image = form.watch(`${fieldPath}`);
  const imageUrl = form.watch(`${fieldName}Url`);
  const inputUrl = form.watch(`${fieldUrl}`);

  return (
    <>
      {_.isEmpty(imageUrl) && _.isEmpty(inputUrl) ? (
        <SelectImage
          sx={{ height: { xs: '150px', md: '350px' } }}
          spacing={1}
          onClick={() => {
            fileInputRef.current.click();
          }}
        >
          <UploadIcon />
          <Typography>이미지 파일 선택</Typography>
        </SelectImage>
      ) : (
        <Stack spacing={1}>
          <Box
            component="img"
            alt={!!image ? image?.name : '시설물 이미지'}
            src={_.isEmpty(imageUrl) ? inputUrl : imageUrl}
            sx={{
              width: '100%',
              maxHeight: { xs: '150px', md: '350px' },
              borderRadius: '10px',
            }}
          />
          <Stack direction="row" justifyContent="space-between">
            <Box />
            <Button
              size="small"
              sx={{ width: 'fit-content', alignItems: 'flex-end' }}
              onClick={() => {
                form.setValue(`${fieldPath}`, null);
                form.setValue(`${fieldName}Url`, null);
                form.setValue(`${fieldUrl}`, null);
              }}
              startIcon={<DeleteIcon />}
            >
              삭제
            </Button>
          </Stack>
        </Stack>
      )}

      <input
        style={{ display: 'none' }}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        ref={fileInputRef}
        onChange={onSelect}
        multiple={false}
      />
    </>
  );
}
